import classNames from 'classnames';
import { Typography } from "../typography/Typography.js";
import styles from "./GroupTitle.module.js";
import { AddButton } from "../addButton/AddButton.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function GroupTitle({
  title,
  size = 'DEFAULT',
  color = 'DEFAULT',
  actionTitle,
  onAction,
  ...typographyProps
}) {
  return /*#__PURE__*/_jsxs("div", {
    className: styles.groupTitle,
    children: [/*#__PURE__*/_jsx(Typography, {
      ...typographyProps,
      margin: false,
      className: classNames(styles.title, {
        [styles.small]: size === 'SMALL',
        [styles.light]: color === 'LIGHT'
      }),
      children: title
    }), /*#__PURE__*/_jsx("div", {
      className: styles.line
    }), actionTitle && /*#__PURE__*/_jsx(AddButton, {
      name: actionTitle,
      variant: "CONDENSED",
      onClick: onAction
    })]
  });
}